import { FC, memo } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import type { EmptyOverlayProps } from "../types";

const DEFAULT_MESSAGE = "No data available";

/**
 * Default empty state overlay for DataTable.
 * Shown when there are no rows to display.
 */
export const EmptyOverlay: FC<EmptyOverlayProps> = memo(function EmptyOverlay({
  message = DEFAULT_MESSAGE,
}) {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100%"
      minHeight={200}
      bgcolor="#edeff1"
    >
      <Stack spacing={1} alignItems="center">
        <Typography variant="h5" color="text.secondary">
          {message}
        </Typography>
      </Stack>
    </Box>
  );
});
